import React from "react";
import { ManageCustodian } from "../../../containers";

const TradeCustodian = (props) => {
  return <ManageCustodian {...props} />;
};

export default TradeCustodian;
